"use strict";
// Copyright (c) 2026 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParsedTokenTxType = exports.XecTxType = void 0;
var XecTxType;
(function (XecTxType) {
    XecTxType["Received"] = "Received";
    XecTxType["Sent"] = "Sent";
    XecTxType["Staking"] = "Staking Reward";
    XecTxType["Coinbase"] = "Coinbase Reward";
})(XecTxType || (exports.XecTxType = XecTxType = {}));
var ParsedTokenTxType;
(function (ParsedTokenTxType) {
    ParsedTokenTxType["AgoraOffer"] = "Agora Offer";
    ParsedTokenTxType["AgoraCancel"] = "Agora Cancel";
    ParsedTokenTxType["AgoraRelist"] = "Agora Relist";
    ParsedTokenTxType["AgoraBuy"] = "Agora Buy";
    ParsedTokenTxType["AgoraSale"] = "Agora Sale";
    ParsedTokenTxType["FanOut"] = "Fan Out";
    ParsedTokenTxType["BlitzPlay"] = "Blitz play";
})(ParsedTokenTxType || (exports.ParsedTokenTxType = ParsedTokenTxType = {}));
//# sourceMappingURL=types.js.map